import Icon       from "_components/atoms/icon";
import Typography from "_components/atoms/typography";

import useStyles from "./styles";

const component = ( { onClick, isActive, activeIconName, iconName, title } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.btnContainer }>
			<div
				className = { `${ classes.iconContainer } ${ isActive ? "active" : "" }` }
				onClick   = { onClick }
			>
				<Icon
					className       = { classes.icon }
					name            = { isActive ? activeIconName : iconName }
					sameInBothTheme = { isActive }
				/>
			</div>

			<Typography
				className = { classes.iconText }
				title     = { title }
			/>
		</div>
	);
};

export default component;